export const RenderQueryExportInBackgroundResults = (maxExportRecordCount: number) => (
  <span>
    Your query returned more than {maxExportRecordCount}{' '}
    records. The export request will be processed in the background and a{' '}
    <i className="fal fa-file-exclamation color-yellow" /> icon will appear next to
    the DATA link in the header when the report is ready. This may take a few
    minutes.
</span>
);


